import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { VisualizationTypes } from 'reporting-data/tsTypes/visualization';
//@ts-expect-error Untyped import
import { LegendPosition, LegendWidth } from '../commonRecords';
export const Events = checked.record({
  onPointClick: checked.func().optional()
}, 'Events');
export const VennLayer = checked.record({
  dataset: checked.string(),
  dataColumn: checked.string(),
  setsColumn: checked.string(),
  listIds: checked.list(checked.number()).optional()
}, 'VennLayer');
export const VennStyles = checked.record({
  // Color configuration
  colors: checked.any().optional(),
  // Data labels styling
  dataLabels: checked.any().optional(),
  tooltipDisabled: checked.boolean().optional(),
  // Legend configuration
  legendPosition: LegendPosition.optional(),
  legendWidth: LegendWidth.optional()
}, 'VennStyles');
export const VennChartOptions = checked.record({
  type: checked.string(),
  data: checked.any().optional(),
  dataLabels: checked.any().optional(),
  legendPosition: LegendPosition.optional(),
  legendWidth: LegendWidth.optional(),
  tooltipDisabled: checked.boolean().optional(),
  chart: checked.any().optional(),
  legend: checked.any().optional()
}, 'VennChartOptions');
export const VennVisualizationRecord = checked.record({
  type: checked.string().always(VisualizationTypes.VENN),
  data: checked.map(Dataset),
  events: Events.optional(),
  layer: VennLayer,
  style: VennStyles
}, 'VennVisualizationRecord');